// extracted by mini-css-extract-plugin
module.exports = {"container":"AssetType_container__3KTnr","card":"AssetType_card__yPdeS","img":"AssetType_img__1PqRN","label":"AssetType_label__2dUUd"};